// src/features/tower/storeReadiness/components/StatusLegend.tsx

import React from "react";

const LEGEND = [
  { color: "#DC2626", label: "Not started" },
  { color: "#F59E0B", label: "In progress" },
  { color: "#2563EB", label: "Awaiting verification" },
  { color: "#16A34A", label: "Complete" },
  { color: "#DC2626", label: "Blocked" },
  { color: "#9CA3AF", label: "Excepted" },
];

export function StatusLegend() {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 14,
        padding: "10px 14px",
        background: "var(--ct-surface)",
        border: "1px solid var(--ct-line)",
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      {LEGEND.map((item) => (
        <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: 3,
              background: item.color,
              flex: "none",
            }}
          />
          <span style={{ fontSize: 12, color: "var(--ct-ink-2)" }}>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
